import { QuestionnaireSubmission, QuestionnaireTemplate } from '@/types';

// Labels that ARE the job-title question, compared with spacing/punctuation
// stripped. Live templates ask "Job Title" (Safety Critical) and "Current Job"
// (Health Surveillance Part 1). Exact match only — several screening questions
// merely mention the word "job".
const JOB_TITLE_LABELS = new Set(['jobtitle', 'currentjob', 'jobrole', 'occupation']);

const normalizeLabel = (label: string): string =>
  String(label || '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');

/**
 * The patient's job title as answered in this appointment's questionnaires.
 * Bookings made through the public/company forms often arrive without one, but
 * the health questionnaire asks for it — use it to pre-fill the certificate's
 * Job Title so the technician only has to confirm. Latest submission wins;
 * returns '' when never answered.
 */
export const findSubmittedJobTitle = (
  submissions: QuestionnaireSubmission[],
  questionnairesById: Map<string, QuestionnaireTemplate>
): string => {
  for (let i = submissions.length - 1; i >= 0; i -= 1) {
    const submission = submissions[i];
    const templateQuestions = questionnairesById.get(submission.templateId)?.questions || [];
    for (const question of templateQuestions) {
      if (!JOB_TITLE_LABELS.has(normalizeLabel(question.label))) continue;
      const answer = String(submission.answers?.[question.id] ?? '').trim();
      if (answer) return answer;
    }
  }
  return '';
};
